import { styled } from 'styled-components'
import { onMediumScreen } from 'mixtiles-web-common'

export const Overlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 4;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 24px 0;
  text-align: center;
  pointer-events: none;

  ${onMediumScreen()} {
    padding-top: 80px;
  }
`

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 360px;

  ${onMediumScreen()} {
    gap: 16px;
    max-width: none;
  }
`

export const Title = styled.h2`
  margin: 0;
  font-size: 32px;
  line-height: 1.15;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black};

  ${onMediumScreen()} {
    font-size: 40px;
    /* The design's 0.8 leading only works on one line. The negative margin keeps that
       spacing, while titles that wrap in longer translations get readable leading. */
    line-height: 1.1;
    margin-block: -0.15em;
  }
`

export const Subtitle = styled.p`
  margin: 0;
  font-size: 20px;
  line-height: 1.25;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.black};

  ${onMediumScreen()} {
    /* Same one-line spacing as the design's 1.0 leading; see Title. */
    margin-block: -0.125em;
  }
`

export const Buttons = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 20px;
  /* Overlay is pointer-events:none; re-enable on the buttons. */
  pointer-events: auto;

  ${onMediumScreen()} {
    margin-top: 32px;
  }
`
